import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
    UrlTree,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AuthService } from '../../../shared/services/auth.service';
import { AppUserType } from '../../../shared/models/user.model';

/**
 * Route guard for ENTERPRISE-only surfaces (e.g. Settings).
 * Mirrors AuthGuard, but additionally checks the resolved user role.
 */
@Injectable({ providedIn: 'root' })
export class EnterpriseGuard {
    constructor(
        private authService: AuthService,
        private router: Router,
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ):
        | boolean
        | UrlTree
        | Promise<boolean | UrlTree>
        | Observable<boolean | UrlTree> {
        return this.authService.userDetails.pipe(
            filter((userDetails) => !!userDetails?.app_user_type_id),
            take(1),
            map((userDetails) => {
                if (userDetails.app_user_type_id === AppUserType.ENTERPRISE) {
                    return true;
                }
                return this.router.createUrlTree(['/main']);
            }),
        );
    }
}
